// Captures that inherit nothing from the ambient scope, for a process whose async context does not
// reach the code that logs. The api is that process: its LoopBack model layer runs outside the request
// that called it, so the ambient isolation scope and active span there belong to another request, and a
// top-level capture stamps that request's url, trace and breadcrumbs on the event.
//
// The same three paths sentryError closes in packages/api/utils/sentry-error.js: a fresh scope for
// this event, an empty isolation scope so foreign breadcrumbs do not concatenate in, and no active span
// so contexts.trace is not stamped from it. The capture goes through the client, because the top-level
// capture applies the ambient scope on top. The logger has no request to put back, so the event carries
// none, which is correct where the alternative is somebody else's.
//
// Redaction still runs: sentryInit registers it on the GLOBAL scope, which every capture merges first.
const Sentry = require('./sentry');

const detached = send => {
  const client = Sentry.getClient();
  if (!client) return;
  Sentry.withIsolationScope(new Sentry.Scope(), () => {
    Sentry.withActiveSpan(null, () => send(client, new Sentry.Scope()));
  });
};

module.exports = {
  captureException: err => detached((client, scope) => client.captureException(err, { originalException: err }, scope)),
  captureMessage: (message, level) => detached((client, scope) => client.captureMessage(message, level, undefined, scope)),
};
